import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import store from "@/store"

import NotFound from '@/views/404.vue'
import Login from '@/views/login.vue'
import Home from '@/views/home.vue'
import Doc from '@/views/doc.vue'

import AdminCategory from '@/views/admin/admin-category.vue'
import AdminDoc from '@/views/admin/admin-doc.vue'
import AdminUser from '@/views/admin/admin-user.vue'
import AdminStatistic from '@/views/admin/admin-statistic.vue'
import AdminArticle from '@/views/admin/admin-article.vue'
import AdminRecommend from '@/views/admin/admin-recommend.vue'


const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/doc',
        name: 'Doc',
        component: Doc
    },
    {
        path: '/admin/article',
        name: 'AdminArticle',
        component: AdminArticle,
        meta: {
            loginRequire: true
        }
    },
    {
        path: '/admin/category',
        name: 'AdminCategory',
        component: AdminCategory,
        meta: {
            loginRequire: true
        }
    },
    {
        path: '/admin/doc',
        name: 'AdminDoc',
        component: AdminDoc,
        meta: {
            loginRequire: true
        }
    },
    {
        path: '/admin/user',
        name: 'AdminUser',
        component: AdminUser,
        meta: {
            loginRequire: true
        }
    },
    {
        path: '/admin/recommend',
        name: 'AdminRecommend',
        component: AdminRecommend,
        meta: {
            loginRequire: true
        }
    },
    {
        path: '/admin/statistic',
        name: 'AdminStatistic',
        component: AdminStatistic,
        meta: {
            loginRequire: true
        }
    },
    // 定义一个404路由，当所有路径都没有匹配时，将会进入这个路由
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    },
]

const router = createRouter({
    //history: createWebHistory(process.env.BASE_URL),   // 使用 history 模式
    history: createWebHashHistory(process.env.BASE_URL), // 使用 hash 模式
    routes
})


// 路由登录拦截
router.beforeEach((to, from, next) => {
    // 要不要对meta.loginRequire属性做监控拦截
    if (to.matched.some(function (item) {
        console.log(item, "是否需要登录校验：", item.meta.loginRequire);
        if (item.meta == undefined || item.meta.loginRequire == undefined) {
            return false
        }
        return item.meta.loginRequire
    })) {
        const loginUser = store.state.user;
        console.log('----------loginUser----------')
        console.log('state: ', store.state);
        console.log('loginUser: ', loginUser);
        console.log('id: ', loginUser.id)
        console.log('loginName: ', loginUser.loginName)
        console.log('-----------------------------')
        //Tool.isEmpty(loginUser)
        if (loginUser.id == undefined || loginUser.id == '' || loginUser.id == "undefined") {
            console.log("用户未登录！");
            next('/');
        } else {
            next();
        }
    } else {
        next();
    }
});

// 跳转到顶部
router.afterEach(() => {

    // 获取到前面打过标签的元素，将其scrollTop属性设置为0
    document.documentElement.scrollTop = 0
    // 滚动条可能出现在HTML元素上而不是body上，确保兼容性，同时将HTML和body中scrollTop属性设置为0
    document.body.scrollTop = 0

    // 或者
    //window.scrollTo(0, 0);

});

export default router
